module.exports = __webpack_public_path__ + "media/images/kyc_example -6d5685bfd64669471f70f1bb712e14f2.png";